export default "__VITE_ASSET__BNIkzYbx__"